import { Button } from "PFComponents/button";
import React, { JSX } from "react";
import { useTranslation } from "react-i18next";

import { useAnalyticsModalContext } from "../../top_actions_panel/analytics_modal_context_provider";
import css from "./columns.module.scss";

type TemplateColumnProps = {
  templateName: string | undefined;
  templateId?: number;
};

export const TemplateColumn = ({ templateName, templateId }: TemplateColumnProps): JSX.Element => {
  const { t } = useTranslation("insights", { keyPrefix: "templates" });
  const { open } = useAnalyticsModalContext();
  return (
    <Button
      kind="text"
      onClick={() => {
        if (templateId) {
          open({ templateId });
        }
      }}
    >
      <div className={css.templateName}>{templateName ?? t("defaultTemplateName")}</div>
    </Button>
  );
};
